import React, { FC, useState, ReactElement } from 'react'
import { Popper as MuiPopper, ClickAwayListener } from '@mui/material'

type Props = {
  getContent: (onClose: () => void) => JSX.Element
  children: ReactElement | ReactElement[]
  // Just a prop name which will be passed back to each child to trigger open event
  trigger: string
  anchorEl?: null | HTMLElement
  className?: string
  onOpen?: (event: React.MouseEvent<HTMLElement>) => void
  onClose?: () => void
}

export const Popper: FC<Props> = ({
  getContent,
  children,
  anchorEl: anchorElProp = null,
  className,
  trigger,
  onOpen,
  onClose,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(anchorElProp)

  const open = Boolean(anchorEl)

  const handleClose = () => {
    onClose?.()
    setAnchorEl(null)
  }

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    onOpen?.(event)
    setAnchorEl(anchorEl ? null : event.currentTarget)
  }

  return (
    <>
      {React.Children.map(children, (child) => React.cloneElement(child, { [trigger]: handleOpen }))}
      <MuiPopper className={className} open={open} anchorEl={anchorEl}>
        <ClickAwayListener onClickAway={handleClose}>{getContent(handleClose)}</ClickAwayListener>
      </MuiPopper>
    </>
  )
}
